import { DivisionLayout } from '../components/layout/DivisionLayout';

const divisionData = {
  divisionName: 'Laser',
  accentColor: '#7030f0',
  heroImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/fitvr8ev_image.png',
  aboutText: [
    {
      text: '<strong>Catworth Laser</strong> provides precision laser cutting services for the processing of <strong>mild steel, stainless steel, aluminum, and wear-resistant plate materials</strong>. Utilizing <strong>high-performance fiber laser technology</strong>, we deliver accurate, repeatable cutting solutions to support mining, manufacturing, and industrial applications.'
    },
    {
      text: 'Our operation is focused on processing materials to customer drawings, supporting both <strong>once-off components and high-volume production</strong>. <strong>Catworth Laser</strong> is also well positioned to process customer-supplied (free issue) material, offering flexible manufacturing support with competitive, cost-effective processing. With an emphasis on quality, speed, and consistency, <strong>Catworth Laser</strong> forms a critical part of the <strong>Catworth</strong> manufacturing ecosystem.'
    }
  ],
  aboutImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/1stgaql3_image.png',
  galleryImages: [
    'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/t0pkxd7u_Laser-cut-parts-etching-pallet-1000x750-1.jpeg',
    'https://images.unsplash.com/photo-1764114235896-034c8772de01?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1689960253762-7c761d1ddbd6?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  capabilities: [
    { title: 'High-Precision Fiber Laser Cutting', description: 'Clean, accurate cutting across a wide range of materials.' },
    { title: 'Heavy Plate Processing (Up to 70mm)', description: '40kW fiber laser capability for thick plate applications.' },
    { title: 'Multi-Material Processing', description: 'Mild steel, stainless steel, aluminum, and Hardox® wear plate.' },
    { title: 'Manufacturing to Drawings', description: 'Direct processing from DXF, DWG, and technical files.' },
    { title: 'Free Issue Material Processing', description: 'Efficient processing of customer-supplied material.' },
    { title: 'Prototype to Production', description: 'Scalable from once-off components to high-volume runs.' },
  ],
};

export const Laser = () => {
  return <DivisionLayout {...divisionData} />;
};

export default Laser;
